import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { SelectableChip } from '@aimsos/ui';

import { TRAIT_QUICK_FILTERS } from '../../constants/intelligence.js';

/**
 * The Traits chips: All, Role in the deal, Deal, Interests, Communication,
 * Personal (CT-5715). Same markup as the Activity chips: each one is a toggle
 * button (`aria-pressed`) and exactly one is on.
 */
const TraitQuickFilters = memo(function TraitQuickFilters({ value, onChange, disabled = false }) {
  const { t } = useTranslation('unified-profiles');

  return (
    <div
      role="group"
      aria-label={t('intelligence.traits.quickFilters.ariaLabel')}
      data-testid="trait-quick-filters"
      className="flex flex-wrap items-center gap-2"
    >
      {TRAIT_QUICK_FILTERS.map((id) => (
        <SelectableChip
          key={id}
          size="m"
          selected={value === id}
          disabled={disabled}
          // One handler per chip: the id is the payload, so no event round-trip.
          onClick={() => onChange(id)}
        >
          {t(`intelligence.traits.quickFilters.${id}`)}
        </SelectableChip>
      ))}
    </div>
  );
});

export default TraitQuickFilters;
